module.exports = __webpack_public_path__ + "banner-default@2x-514d3dd99acb8dfa4c12b6e0fda18600.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/app/img/banner-default@2x.jpg
// module id = 411
// module chunks = 0